module.exports = __webpack_public_path__ + "static/media/Milk_lite5.3f28b026.jpg";